export const navbarListItems = [
  {
    title: "Restaurant",
    link: "/",
    role: "admin"
  },
  {
    title: "Restaurant Employee",
    link: "restaurant-employee",
    role: "admin",
  },
  {
    title: "OTP",
    link: "otp",
    role: "admin",
  },
  {
    title: "Game Setup",
    keyword: "admin-game",
    icon: "bx bx-joystick-button",
    role: "both",
    multi: true,
    linkList: [
      {
        title: "Cuisine",
        link: "cuisine",
        icon: "bx bx-sitemap",
        multi: false,
      },
      // {
      //   title: "Brand",
      //   link: "brand",
      //   icon: "bx bx-joystick",
      //   multi: false,
      // },
      {
        title: "Ingredient",
        link: "ingredient",
        icon: "bx bx-joystick",
        multi: false,
      },
      // {
      //   title: "Unit Of Measurement",
      //   link: "unit-of-measurement",
      //   icon: "bx bx-joystick",
      //   multi: false,
      // },

      {
        title: "Condiment Recipe",
        link: "condiment-recipe",
        icon: "bx bx-joystick",
        multi: false,
      },

      {
        title: "Customization Recipe",
        link: "customization-recipe",
        icon: "bx bx-joystick",
        multi: false,
      },

      {
        title: "Item Recipe",
        link: "item-recipe",
        icon: "bx bx-joystick",
        multi: false,
      },
    ],
  },
  // {
  //   name: "Cuisine",
  //   linkTo: "cuisine",
  // },
  // {
  //   name: "Item",
  //   linkTo: "item",
  // },

  // {
  //   name: "Ingredient",
  //   linkTo: "ingredient",
  // },
  // {
  //   name: "User Admin",
  //   linkTo: "user-admin",
  // },
  // {
  //   name: "Brand",
  //   linkTo: "brand",
  // },
  // {
  //   name: "Unit Of Measurement",
  //   linkTo: "unit-of-measurement",
  // },
];
